const CONF = {
  CLP: { locale: "es-CL", prefix: "$", decimals: 0 },
  USD: { locale: "es-EC", prefix: "USD ", decimals: 2 },
};

export const money = (n, cur = "CLP") => {
  const c = CONF[cur] || CONF.CLP;
  const v = Number(n || 0);
  return c.prefix + (c.decimals ? v.toLocaleString(c.locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : Math.round(v).toLocaleString(c.locale));
};

export const LOCALE_BY_CUR = { CLP: "es-CL", USD: "es-EC" };
